import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';

export function NavSearch({ inputRef, value, onChange, onSubmit }) {
	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			onSubmit();
		}
		if (event.key === 'Escape') onChange('');
	};

	return (
		<TextField
			inputRef={inputRef}
			value={value}
			onChange={(event) => onChange(event.target.value)}
			onKeyDown={handleKeyDown}
			placeholder="Search pages (Ctrl+K)"
			size="small"
			sx={{ mx: 2, my: 1.5 }}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon fontSize="small" />
						</InputAdornment>
					),
				},
			}}
		/>
	);
}

NavSearch.propTypes = {
	inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
	value: PropTypes.string,
	onChange: PropTypes.func,
	onSubmit: PropTypes.func,
};
